<template lang="pug">
    div(
        class="_mdls _p2 _con",
        :class="_class",
        :style="{ transformOrigin }",
        :dir="direction")
        div(class="_mdlsa", :style="origin")
        div(class="_mdlsdef _p2def", :style="{ width, height }", ref="content")
            slot
</template>

<script>
    import anchored from '../private/anchored';


    /**
     * An unstyled popover that exposes a slot to render inside of it.
     */
    export default {
        name: 'ib-popover2',

        mixins: [
            anchored
        ],

        props: {
            /**
             * Explicit width in CSS units (optional).
             */
            width: String,
            /**
             * Explicit height in CSS units (optional).
             */
            height: String,
            /**
             * If `true`, display flush against anchor with no arrow.
             */
            flush: Boolean,
            /**
             * Controls shadow; `low`, `med` or `high` supported. Default is `med`.
             */
            elevation: String
        },

        computed: {
            offset() {
                return this.flush ? 0 : 12;
            },
            transformOrigin() {
                return (this.origin.left || -this.offset + 'px') + ' ' + (this.origin.top || -this.offset + 'px');
            },
            direction() {
                const app = this.$root.__app;
                return app ? app.direction : 'ltr';
            },
            _class() {
                return {
                    _v: this.visible && !this.occluded,
                    _p2n: this.nested,
                    ['_p'+this.actual]: true,
                    ['_a'+this.align]: true,
                    ['_e'+this.elevation]: this.elevation
                };
            }
        },

        mounted() {
            if (!this.$overlay()) {
                console.error('Instantiate with $overlay');
            }
        },

        methods: {
            /**
             * Emits 'open' event
             * @event
             * @type {null}
             */
            onOpen() {
                this.$emit('open');
            },
            /**
             * Emits 'close' event
             * @event
             * @type {null}
             */
            onClose() {
                this.$emit('close');
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    /** Modeless dialog classes */
    ._mdls {
        display: flex;
        position: fixed;
        max-width: calc(~'100% - 8px');
        visibility: hidden;

        & {
            transform: scale(.01);
        }
        &._v { /* visible */
            transform: scale(1);
            transition: transform .1s;
            ._mdlsa::before,
            ._mdlsa::after,
            ._mdlsdef {
                visibility: visible;
            }
        }

        &._ptop,
        &._pbottom {
            flex-direction: row;
        }
        &._ptop {
            > ._mdlsa::before,
            > ._mdlsa::after {
                bottom: 66%;
                left: 33%;
                width: 35.3553%;   /** .5 / sqrt(2) */
                height: 70.7107%;  /** 1 / sqrt(2) */
            }
        }
        &._pbottom {
            > ._mdlsa::before,
            > ._mdlsa::after {
                top: 66%;
                left: 33%;
                width: 35.3553%;
                height: 70.7107%;
            }
        }
        &._pleft,
        &._pright {
            flex-direction: column;
        }
        &._pleft {
            > ._mdlsa::before,
            > ._mdlsa::after {
                right: 66%;
                top: 33%;
                width: 70.7107%;
                height: 35.3553%;
            }
        }
        &._pright {
            > ._mdlsa::before,
            > ._mdlsa::after {
                left: 66%;
                top: 33%;
                width: 70.7107%;
                height: 35.3553%;
            }
        }

        &._astart,
        &._aleft[dir=ltr],
        &._aright[dir=rtl] {
            justify-content: flex-start;
        }
        &._aend,
        &._aright[dir=ltr],
        &._aleft[dir=rtl] {
            justify-content: flex-end;
        }
        &._acenter {
            justify-content: center;
        }
    }

    ._mdlsa {
        position: absolute;
        overflow: hidden;
        background-color: inherit;
        &::before,
        &::after {
            content: '';
            position: absolute;
            -webkit-transform: rotate(45deg);
                    transform: rotate(45deg);
        }
        &::before {
            box-shadow: 0 0 16px rgba(0,0,0,.1);
            z-index: -1;
        }
        &::after {
            background-color: inherit;
            z-index: 1;
        }
    }

    ._mdlsdef {
        position: relative;
        background-color: inherit;
        .shadow-med();
    }
    &._elow ._mdlsdef {
        .shadow-low();
    }
    &._ehigh ._mdlsdef {
        .shadow-high();
    }

    ._p2 {
        z-index: @z-popover;
        background-color: @bg-modeless;
    }
    ._p2n {
        z-index: @z-ovl-popover;
    }
    ._p2def {
        border-radius: 3px;
    }
</style>
